import { NotificationAlertLowShieldOutlineBaseIconRaw } from '@tableau/icons/NotificationAlertLowShieldOutlineBaseIcon/raw';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';

import { cssClass } from '../../style';

const accessDeniedIconProperty = ReactiveRawIconRegistry.register(NotificationAlertLowShieldOutlineBaseIconRaw, 16);

export namespace SharedWithMeSpaceStyle {
  export const sharedWithMeSpaceCssPrefix = 'SharedWithMeSpace';

  export const getAccessDeniedIcon = () => cssClass(sharedWithMeSpaceCssPrefix, 'access-denied-icon', {
    display: 'inline-block',
    backgroundImage: `var(${accessDeniedIconProperty})`,
    backgroundPosition: 'left center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '16px 16px',
    height: '16px',
    marginLeft: '6px',
    width: '16px',
  });
}